import { createFileRoute } from "@tanstack/react-router";
import SitePage from "@/components/SitePage";
import { buildHead, breadcrumbLD, touristTripLD, SITE_URL } from "@/content/seo";
import { landingContent, pageFaqLD } from "@/content/landing-content";

const TITLE = "Private Boat Rental Vilamoura — Crewed Yacht Charter | Morningstar";
const DESC =
  "Private boat rental in Vilamoura aboard Morningstar — a 200 m² crewed yacht for up to 18 guests. Half-day, sunset, Benagil and full-day from Marina de Vilamoura.";
const PATH = "/private-boat-rental-vilamoura";
const URL = `${SITE_URL}${PATH}`;
const CONTENT = landingContent.privateBoatRentalVilamoura;

export const Route = createFileRoute("/private-boat-rental-vilamoura")({
  component: () => (
    <SitePage
      lang="en"
      heroOverride={{
        eyebrow: "Private Boat Rental · Vilamoura · Algarve",
        title: "Private boat rental in Vilamoura aboard ",
        titleAccent: "Morningstar.",
        sub: "A 200 m² crewed yacht for up to 18 guests — your private boat rental from Marina de Vilamoura. Skipper, deckhand, fuel, drinks and Portuguese tapas included. No licence needed.",
        ctaPrimary: "View rental options",
        ctaSecondary: "Request a quote",
      }}
      pageContent={CONTENT.en}
    />
  ),
  head: () =>
    buildHead({
      lang: "en",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords:
        "private boat rental vilamoura, boat rental vilamoura, private boat hire vilamoura, vilamoura private boat, rent a private boat vilamoura",
      altPath: { en: PATH, pt: "/pt/aluguer-de-barco-vilamoura" },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            touristTripLD({
              name: "Private Boat Rental from Vilamoura",
              description: DESC,
              url: URL,
            }),
          ),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Home", path: "/" },
              { name: "Private Boat Rental Vilamoura", path: PATH },
            ]),
          ),
        },
        { type: "application/ld+json", children: JSON.stringify(pageFaqLD(CONTENT.en.faqs)) },
      ],
    }),
});